import { PriorityActionType } from "../../types/apiTypes";
import { priorityActionTags } from "../../types/genereal";

type Props = {
  tag: PriorityActionType;
};

export const RoleTag = ({ tag }: Props) => {
  if (!tag) return null;

  const { label, color, borderColor, backgroundColor } =
    priorityActionTags[tag];

  return (
    <span
      style={{
        color,
        border: `1px solid ${borderColor}`,
        backgroundColor,
        padding: "6px 12px",
        fontSize: "12px",
        lineHeight: "13px",
        fontWeight: 500,
        borderRadius: "16px",
      }}
    >
      {label}
    </span>
  );
};
